import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal,
  Col,
  Button,
  Form,
  message,
  Spin,
} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import { selectPeriodoFiscalSelected, updatePeriodoFiscalSelected } from 'store/auth';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';

const ModalChangeFiscalPeriod = ({
  editable,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [open, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const periodoFiscalSelected = useSelector(selectPeriodoFiscalSelected);

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      setLoading(true);
      const _periodosFiscales = await getPeriodosFiscales();
      if (mounted) {
        setPeriodosFiscales(_periodosFiscales);
        setLoading(false);
      }
    };
    if (open) {
      fetchData();
    }
    return () => { mounted = false; };
  }, [open]);

  const onCancel = () => setVisible(false);

  const periodoToString = (periodo = periodoFiscalSelected) => {
    if (!periodo?.periodo) {
      return 'No seleccionado';
    }
    const periodoStr = `${periodo?.periodo}`;
    const vigenteStr = (periodo?.vigente && ' (vigente)') || '';
    return `${periodoStr}${vigenteStr}`;
  };

  const onFinish = async () => {
    setLoading(true);
    const { periodoFiscal } = form.getFieldsValue();
    const payload = periodosFiscales.find((pf) => pf.id === periodoFiscal);
    dispatch(updatePeriodoFiscalSelected(payload));
    setTimeout(() => {
      onCancel();
      message.info(`Ejercicio ${periodoToString(payload)} seleccionado correctamente`);
    });
    setLoading(false);
  };

  const rules = {
    periodoFiscal: [{ required: true }],
  };

  return (
    <>
      Ejercicio:
      {' '}
      {editable ? (
        <Button
          onClick={() => setVisible(true)}
          type="link"
          style={{ padding: 0, height: 'auto' }}
        >
          {periodoToString()}
          {' '}
          <EditOutlined />
        </Button>
      ) : periodoFiscalSelected.periodo}

      <Modal
        title={(
          <FormSubmitControls
            label="Selección de Ejercicio"
            onFinish={() => form.submit()}
            onCancel={onCancel}
            loading={loading}
          />
        )}
        open={open}
        footer={null}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
      >
        <Spin tip="Cargando..." spinning={loading}>
          <Form
            layout="vertical"
            form={form}
            onFinish={() => onFinish()}
            initialValues={{ periodoFiscal: periodoFiscalSelected?.id }}
          >
            <Col span={24}>
              <Form.Item
                name="periodoFiscal"
                rules={rules.periodoFiscal}
                hasFeedback
                label="Ejercicio"
              >
                <Select
                  dataSource={periodosFiscales}
                  render={(e) => `${e.periodo} ${e.vigente ? ' (Vigente)' : ''}`}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

ModalChangeFiscalPeriod.propTypes = {
  editable: PropTypes.bool,
};

ModalChangeFiscalPeriod.defaultProps = {
  editable: true,
};

export default ModalChangeFiscalPeriod;
